import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { api, setToken } from '@/lib/api';
import { useAuth, type AuthUser } from '@/hooks/use-auth';

export default function AuthMagicPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const ranRef = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const token = params.get('token');
    if (!token) {
      setError('Missing token in URL.');
      return;
    }

    (async () => {
      try {
        const r = await api.post<{ access_token: string; user: AuthUser }>(
          '/auth/magic/exchange',
          { token }
        );
        setToken(r.data.access_token);
        await refresh();
        toast.success(`Welcome, ${r.data.user.display_name}`);
        navigate('/', { replace: true });
      } catch (e: unknown) {
        const msg = e instanceof Error ? e.message : 'Magic link failed';
        setError(msg);
      }
    })();
  }, [params, navigate, refresh]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-sm text-center space-y-3">
          <div className="text-3xl font-semibold"><span className="text-accent-400">KAF</span> Warehouse</div>
          <p className="text-red-400 text-sm">{error}</p>
          <p className="text-xs text-muted">
            The link may be expired or already used. Ask an admin to send you a new one.
          </p>
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="text-xs text-accent-400 underline"
          >
            Back to sign-in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-muted text-sm">
      Signing you in...
    </div>
  );
}
